export default "__VITE_ASSET__CQsgYte8__"